import React from "react";
import { useQuery } from "@apollo/react-hooks";

const CustomQuery = ({ children, query, id, category_name }) => {
  const { data, loading, error } = useQuery(query, {
    variables: { id: id, category_name: category_name }
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {JSON.stringify(error)}</p>;
  return children({ data });
};

export default CustomQuery;
